<template>
  <div id="app" class="router-view-box">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>
<style lang="less">
  html,body,.router-view-box {
    height: 100%;
    background: #FAF9F9;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue